import { api as gridApi } from './trucksSensorsViewGridActions';
import { setDefaultConfig, deleteSensorProviderConfig } from '../../../services/SensorProviders/sensorProvidersService';
import { api as messageDialogApi } from '../../MessageDialog/messageDialogActions';
import Network from 'infrastructure/js/modules/network';

/////////////////////////////////////////
// ACTION TYPES - PUBLIC, FOR REDUCERS
export const actionTypes = {};

////////////////////////////////////////////////////////////////
// PLAIN ACTION CREATORS - PRIVATE, FOR LOCAL DISPATCH ONLY
const actions = {};

/////////////////////////////////////////////////////
// METHODS FOR JSX PROPS - PUBLIC, ALL THUNK TYPE
export let jsxActions = {};

jsxActions.reload = function () {
  return function (dispatch, getState) {
    gridApi.reload(dispatch, getState)();
  };
};

jsxActions.clearFilters = function () {
  return function (dispatch, getState) {
    gridApi.clearFilters(dispatch, getState)();
  };
};

/////////////////////////////////////////////////////////////////////////
// API METHODS - PUBLIC, FOR OTHER ACTION MODULES (and internal use)
export let api = {};

api.setConfigAsDefault = function (dispatch, getState) {
  return function ({ id }) {
    return setDefaultConfig(id).then((response) => {
      if (!Network.isResponseValid(response)) {
        messageDialogApi.responseError(dispatch, getState)(response);
        console.error(`Setting config with id: ${id} as default failed`, response);
        return { success: false };
      }
      gridApi.reload(dispatch, getState)();
    });
  };
};

api.deleteConfigs = function (dispatch, getState) {
  return function (ids = []) {
    if (!ids || ids?.length === 0) {
      console.error('No config data provided for deletion');
      return;
    }

    return deleteSensorProviderConfig(ids).then((response) => {
      if (!Network.isResponseValid(response)) {
        messageDialogApi.responseError(dispatch, getState)(response);
        console.error('Deleting configs failed', response);
        return { success: false };
      }

      messageDialogApi.showSuccess(dispatch, getState)('mat.administration.settings.trucksSensors.view.dialog.confirm.delete', { count: ids.length });
      gridApi.reload(dispatch, getState)();
    });
  };
};
